<!--  -->
<template>
  <div class="contianer">
    <div class="con">
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_03.png"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_05.png"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_06.png"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_08.png"
        @click="goto('20117')"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_10.png"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_12.png"
        @click="goto('19576')"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_13.png"
        @click="goto('19715')"
        alt=""
      />
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_15.png"
        alt=""
      />
      <div class="ac1_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_16.png"
            @click="goto('19931')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_17.png"
            @click="goto('19929')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_18.png"
            @click="goto('20206')"
          />
        </div>
      </div>
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_19.png"
        alt=""
      />

      <div class="ac1_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_20.png"
            @click="goto('18768')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_21.png"
            @click="goto('19328')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_22.png"
            @click="goto('19313')"
          />
        </div>
      </div>
      <div class="ac1_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_25.png"
            @click="goto('19315')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_26.png"
            @click="goto('20242')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_27.png"
            @click="goto('20235')"
          />
        </div>
      </div>
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_28.png"
        alt=""
      />
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_29.png"
            @click="goto('19155')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_30.png"
            @click="goto('19554')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_31.png"
            @click="goto('9773')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_32.png"
            @click="goto('20023')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_33.png"
            @click="goto('20055')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_34.png"
            @click="goto('20029')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_36.png"
            @click="goto('20027')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_37.png"
            @click="goto('20025')"
          />
        </div>
      </div>
      <div class="ac2_img">
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_40.png"
            @click="goto('20021')"
          />
        </div>
        <div>
          <img
            alt=""
            src="../../assets/images/h5_25/春节大促_41.png"
            @click="goto('19733')"
          />
        </div>
      </div>
      <img
        class="bgimg"
        src="../../assets/images/h5_25/春节大促_42.png"
        alt=""
      />
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goto(id) {
      let position = window.scrollY
      this.$router.push({ query: { page: position } });
      this.$router.push({
        path: "/productDetails?id=" + id,
      });
    },
  },
  created() {},
  mounted() {
    let recruitScrollY = this.$route.query.page
    window.scroll(0, recruitScrollY) 
  },
};
</script>
<style lang='scss' scoped>
img {
  border: 0;
  margin: 0;
  padding: 0;
  vertical-align: middle;
  width: 100%;
}
.con {
  .ac1_img,
  .ac2_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
  .ac3_img {
    display: flex;
    img {
      cursor: pointer;
    }
  }
}
</style>